import {
  HERO_CATEGORY,
  HERO_EXCERPT,
  HERO_HEAT,
  HERO_HEADLINE,
  HERO_QUICK,
  HERO_TAG,
  HERO_TIME,
} from "@/mocks/news";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20breaking%20news%20theme%20concept%2C%20open%20palms%20holding%20folded%20newspaper%20with%20megaphone%20and%20red%20ribbon%20light%2C%20rich%20vermillion%20and%20amber%20accents%20on%20deep%20charcoal%20background%2C%20dramatic%20soft%20light%2C%20artistic%20magazine%20cover%20style%2C%20high%20detail&width=1600&height=900&seq=dp-hero-main&orientation=landscape";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative isolate flex min-h-[660px] w-full flex-col overflow-hidden md:min-h-[720px]"
    >
      <img
        src={HERO_IMG}
        alt="每日爆料首屏要闻：预付式消费退款难热点头条背景图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/75"></div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>

      <div className="relative z-10 mx-auto mt-28 w-full max-w-7xl px-4 pb-10 pt-6 md:mt-36 md:px-6">
        <div className="flex w-full flex-col gap-8 lg:flex-row lg:items-end">
          <div className="w-full lg:max-w-3xl">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-1 rounded-sm bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-fire-line"></i>
                {HERO_TAG}
              </span>
              <span className="text-xs font-medium text-background-50/70">
                {HERO_CATEGORY}
              </span>
              <span className="text-xs font-medium text-background-50/50">
                {HERO_TIME}
              </span>
            </div>

            <h2 className="font-heading mt-5 text-3xl font-bold leading-snug text-white md:text-5xl md:leading-tight">
              {HERO_HEADLINE}
            </h2>

            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-background-50/85 md:text-base">
              {HERO_EXCERPT}
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#contact"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-[15px] font-semibold text-background-50 transition-colors hover:bg-primary-400"
              >
                <i className="ri-send-plane-line"></i>
                提供线索爆料
              </a>
              <a
                href="#latest"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-[15px] font-semibold text-white backdrop-blur transition-colors hover:bg-background-50/20"
              >
                <i className="ri-arrow-down-line"></i>
                浏览最新资讯
              </a>
            </div>
          </div>

          <aside className="w-full lg:w-[360px] lg:shrink-0">
            <div className="rounded-lg border border-background-50/15 bg-background-950/50 p-4 backdrop-blur-md">
              <div className="flex items-center justify-between border-b border-background-50/10 pb-3">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-white">
                  <i className="ri-time-line text-accent-500"></i>
                  刚刚播报
                </h3>
                <a
                  href="#latest"
                  className="text-xs text-background-50/60 hover:text-white"
                >
                  全部动态
                </a>
              </div>
              <ul className="mt-1 divide-y divide-background-50/10">
                {HERO_QUICK.map((q) => (
                  <li key={q.title} className="py-3">
                    <span className="mb-1 inline-flex items-center rounded-sm bg-accent-500/20 px-1.5 py-0.5 text-[11px] font-medium text-accent-200">
                      {q.tag}
                    </span>
                    <p className="mt-1 text-sm leading-snug text-background-50/90">
                      {q.title}
                    </p>
                    <p className="mt-1 text-[11px] text-background-50/45">{q.time}</p>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}